import moment from "moment";
export const ACTION = {
  UPDATE_SUCCESS: "UPDATE_SUCCESS",
  DELETE_SUCCESS: "DELETE_SUCCESS",
  CREATE_SUCCESS: "CREATE_SUCCESS",
  CREATE_ERROR: "CREATE_ERROR",
  FETCH_SUCCESS: "FETCH_SUCCESS",
  FETCH_SUCCESS2: "FETCH_SUCCESS2",
  FETCH_SUCCESS2Mod: "FETCH_SUCCESS2Mod",
  FETCH_SUCCESS2Mod2: "FETCH_SUCCESS2Mod2",
  FETCH_SUCCESS2UPDATE: "FETCH_SUCCESS2UPDATE",
  FETCH_SUCCESS3: "FETCH_SUCCESS3",
  FETCH_DUO_SUCCESS: "FETCH_DUO_SUCCESS",
  FETCH_ERROR: "FETCH_ERROR",
  FORM_LOAD: "FORM_LOAD",
  ACT_FORM_LOAD: "ACT_FORM_LOAD",
  UPDATE_ID: "UPDATE_ID",
  CREATE_ACT_SUCCESS: "CREATE_ACT_SUCCESS",
  UPDATE_ACT_SUCCESS: "UPDATE_ACT_SUCCESS",
  GET_PATHNAME: "GET_PATHNAME",
  FETCH_SUCCESS_CREATE_TABLE_DATA: "FETCH_SUCCESS_CREATE_TABLE_DATA",
  CREATE_TABLE_DATA_NEW_VALUE: "CREATE_TABLE_DATA_NEW_VALUE",
  CREATE_TABLE_DATA_EXISTING_VALUE: "CREATE_TABLE_DATA_EXISTING_VALUE",
  IS_LOADING: "IS_LOADING",
  IS_CREATING_NEW_ENTRY: "IS_CREATING_NEW_ENTRY",
  CREATE_ACT_SUCCESS_CLEAR: "CREATE_ACT_SUCCESS_CLEAR",
  UPDATE_SUCCESS_CONSULTATION: "UPDATE_SUCCESS_CONSULTATION",
  CLOSE: "CLOSE",
  CLOSE2: "CLOSE2",
  OPEN: "OPEN",
  OPEN2: "OPEN2",
  Fill_FORM_DATA: "Fill_FORM_DATA",
  Fill_FORM_DATA_3_COLUMN_observation: "Fill_FORM_DATA_3_COLUMN_observation",
  Fill_FORM_DATA_3_COLUMN_od: "Fill_FORM_DATA_3_COLUMN_od",
  Fill_FORM_DATA_3_COLUMN_avOD: "Fill_FORM_DATA_3_COLUMN_avOD",
  Fill_FORM_DATA_3_COLUMN_sphOD: "Fill_FORM_DATA_3_COLUMN_sphOD",
  Fill_FORM_DATA_3_COLUMN_cylOD: "Fill_FORM_DATA_3_COLUMN_cylOD",
  Fill_FORM_DATA_3_COLUMN_axeOD: "Fill_FORM_DATA_3_COLUMN_axeOD",
  Fill_FORM_DATA_3_COLUMN_addOD: "Fill_FORM_DATA_3_COLUMN_addOD",
  Fill_FORM_DATA_3_COLUMN_og: "Fill_FORM_DATA_3_COLUMN_og",
  Fill_FORM_DATA_3_COLUMN_avOG: "Fill_FORM_DATA_3_COLUMN_avOG",
  Fill_FORM_DATA_3_COLUMN_sphOG: "Fill_FORM_DATA_3_COLUMN_sphOG",
  Fill_FORM_DATA_3_COLUMN_cylOG: "Fill_FORM_DATA_3_COLUMN_cylOG",
  Fill_FORM_DATA_3_COLUMN_axeOG: "Fill_FORM_DATA_3_COLUMN_axeOG",
  Fill_FORM_DATA_3_COLUMN_addOG: "Fill_FORM_DATA_3_COLUMN_addOG",
  Fill_FORM_DATA_3_COLUMN_od_Pachy: "Fill_FORM_DATA_3_COLUMN_od_Pachy",
  Fill_FORM_DATA_3_COLUMN_og_Pachy: "Fill_FORM_DATA_3_COLUMN_og_Pachy",
  FORM_LOAD_CONSULTATION: "FORM_LOAD_CONSULTATION",
  LOAD_FIRST_TABLE: "LOAD_FIRST_TABLE",
  LOAD_SECOND_TABLE: "LOAD_SECOND_TABLE",
  LOAD_THIRD_TABLE: "LOAD_THIRD_TABLE",
  IMPORT_DATA_MACHINE_PACHY: "IMPORT_DATA_MACHINE_PACHY",
  LOAD_LUNETTES_TABLE: "LOAD_LUNETTES_TABLE",
  Fill_FORM_DATA_3_COLUMN_ChangeDate: "Fill_FORM_DATA_3_COLUMN_ChangeDate",
  Fill_FORM_SolaireAntiUV: "Fill_FORM_SolaireAntiUV",
  Fill_FORM_Antireflet: "Fill_FORM_Antireflet",
  Fill_FORM_FiltreBlue: "Fill_FORM_FiltreBlue",
  Fill_FORM_Photocromic: "Fill_FORM_Photocromic",
  Fill_FORM_Montures_cadre: "Fill_FORM_Montures_cadre",
  IMPORT_DATA_MACHINE_CO_PORTEE: "IMPORT_DATA_MACHINE_CO_PORTEE",
  IMPORT_DATA_MACHINE_CO_finale: "IMPORT_DATA_MACHINE_CO_finale",
  LOAD_History_examen_compl: "LOAD_History_examen_compl",
  MEDICAMENTS_TABLE: "MEDICAMENTS_TABLE",
  ORDONANCE_MEDICAMENTS: "ORDONANCE_MEDICAMENTS",
  ORDONANCE_MEDICAMENTS_HISTORIC: "ORDONANCE_MEDICAMENTS_HISTORIC",
  ORDONANCE_COURRIER_HISTORIC: "ORDONANCE_COURRIER_HISTORIC",
  ORDONANCE_CERT_HISTORIC: "ORDONANCE_CERT_HISTORIC",
  ORDONANCE_QTE: "ORDONANCE_QTE",
  ORDONANCE_DUREE: "ORDONANCE_DUREE",
  COURRIER_ANT: "COURRIER_ANT",
  COURRIER_CONSUL: "COURRIER_CONSUL",
  COURRIER_COMMENT: "COURRIER_COMMENT",
  ORDONANCE_RDV: "ORDONANCE_RDV",
  ORDONANCE_RDV2: "ORDONANCE_RDV2",
  ORDONANCE_dateMod: "ORDONANCE_dateMod",
  FETCH_SUCCESS_MUTU: "FETCH_SUCCESS_MUTU",
  COPY_OD_TO_OG: "COPY_OD_TO_OG",
  LOAD_CRUD_OPTIONS: "LOAD_CRUD_OPTIONS"
};

export const initialState = {
  rowData_mutu: "",
  createTableData_New_value: 4,
  Courrier_Ant_Rows: [],
  Courrier_Consul_Rows: [],
  Courrier_Comment_Rows: [],
  date_ordonance: "",
  date_ordonance2: "",
  id_ordonnance_medicaments: "",
  fk_id_patient_ordo_medic: "",
  medicament: "",
  posologie: "",
  duree: "",
  rdv: "",
  qte: 1,
  DateConsultation: "",
  created_at: "",
  created_by: "",
  fk_id_examen: "",
  fk_id_patientConsul: "",
  id_consultation: "",
  nom_examen: "",
  observation: "",
  od: "",
  od_Pachy: "",
  og: "",
  og_Pachy: "",
  updated_at: "",
  updated_by: "",
  FormData: "",
  open: false,
  open2: false,
  idx: 0,
  size: undefined,
  size2: undefined,
  uploads: [],
  rowData: [],
  rowData2: [],
  rowData3: [],
  idpatient: "",
  nom: "",
  prenom: "",
  civilite: "",
  cin: "",
  date_naissance: "",
  commentaire_sur_patient: "",
  tel: "",
  tel2: "",
  tel3: "",
  nom_mutuelle: "",
  fk_id_civilite: "",
  fk_id_liste_mutuelle: "",
  loading: true,
  error: "",
  success: "",
  dimmer: undefined,
  ID: "",
  date_consultation: "",
  date_consultation_For_Server: "",
  nom_acte: "",
  prix_acte: "",
  remise: "",
  payment: "",
  suplement: "",
  done: "",
  bloc: "",
  didnt_come: "",
  couleur: "",
  fk_id_acte: "",
  fk_id_patient1: "",
  pathname: "",
  // createTableData_Value: [],
  // createTableData_New_value: [],
  // createTableData_Existing_value: [],
  // optionsCreateTableData: [],
  isLoading: false,
  ModalHeader: "Acte Proposé",
  Nom_CategoryBtn: "",
  Nom_Detail_1: "",
  fk_id_categoryBtn: "",
  id_detail_1: "",
  Nom_Detail_2: "",
  fk_id_detail_1: "",
  id_detail_2: "",
  Nom_Detail_3: "",
  fk_id_detail_2: "",
  id_detail_3: "",
  id_examen: "",
  fk_id_patientLunette: "",
  avOD: "",
  sphOD: "",
  cylOD: "",
  axeOD: "",
  addOD: "",
  avOG: "",
  sphOG: "",
  cylOG: "",
  axeOG: "",
  addOG: "",
  ODprintableText: "",
  OGprintableText: "",
  nomPrenomCivilite: "",
  id_lunettes: "",
  SolaireAntiUV: false,
  Antireflet: false,
  FiltreBlue: false,
  SolaireAntiUVtxt: "",
  FiltreBluetxt: "",
  Antireflettxt: "",
  selectionChanged: false,
  MontureNewAVOptions: "",
  TypeCO: "",
  idExamens_Compl: "",
  nom_Examens_Compl: "",
  fk_id_patient_examen_compl: "",
  date_exam_compl: "",
  date_exam_compl_converted: "",
  id_medicaments: "",
  nom_medicament: "",
  index: "",
  ordonnance_date3: "",
  description: "",
  dateLisible: "",
  fk_id_patient: "",
  idcourrier: "",
  date: "",
  idcertificat: "",
  Photocromic: false,
  key1: "",
  category: "",
  value: ""

};

export const reducer = (state, action) => {
  switch (action.type) {
    case ACTION.FETCH_SUCCESS_MUTU:
      return {
        ...state,
        loading: false,
        rowData_mutu: action.payload,
        error: "",
        // ModalHeader: action.title,
      };
    case ACTION.CREATE_TABLE_DATA_NEW_VALUE:
      return {
        ...state,
        loading: false,
        createTableData_New_value: action.payload,
        error: "",
      };
    case ACTION.COURRIER_ANT:
      return {
        ...state,
        Courrier_Ant_Rows: action.value,
      };
    case ACTION.COURRIER_CONSUL:
      return {
        ...state,
        Courrier_Consul_Rows: action.value,
      };
    case ACTION.COURRIER_COMMENT:
      return {
        ...state,
        Courrier_Comment_Rows: action.value,
      };
    case ACTION.ORDONANCE_MEDICAMENTS:
      return {
        ...state,
        id_ordonnance_medicaments: action.value.id_ordonnance_medicaments,
        medicament: action.value.medicament,
        qte: action.value.qte,
        posologie: action.value.posologie,
        duree: action.value.duree,
        od: action.value.od,
        og: action.value.og,
        index: action.value.index,
      };
    case ACTION.ORDONANCE_MEDICAMENTS_HISTORIC:
      return {
        ...state,
        date_ordonance: action.value.date_ordonance,
        date_ordonance2: action.value.date_ordonance2,
        fk_id_patient_ordo_medic: action.value.fk_id_patient_ordo_medic,
        index: action.value.index,
        ordonnance_date3: action.value.ordonnance_date2,
      };
    case ACTION.ORDONANCE_COURRIER_HISTORIC:
      return {
        ...state,
        date: action.value.date,
        dateLisible: action.value.dateLisible,
        description: action.value.description,
        fk_id_patient: action.value.fk_id_patient,
        idcourrier: action.value.idcourrier,
      };
    case ACTION.ORDONANCE_CERT_HISTORIC:
      return {
        ...state,
        date: action.value.date,
        dateLisible: action.value.dateLisible,
        description: action.value.description,
        fk_id_patient: action.value.fk_id_patient,
        idcertificat: action.value.idcertificat,
      };
    case ACTION.ORDONANCE_QTE:
      return {
        ...state,
        qte: action.payload,
      };
    case ACTION.ORDONANCE_DUREE:
      return {
        ...state,
        duree: action.payload,
      };
    case ACTION.ORDONANCE_RDV:
      return {
        ...state,
        rdv: action.payload,
        // ordonnance_date3: action.payload,
      };

    case ACTION.ORDONANCE_dateMod:
      return {
        ...state,
        ordonnance_date3: action.payload,
      };

    case ACTION.MEDICAMENTS_TABLE:
      return {
        ...state,
        id_medicaments: action.value.id_medicaments,
        nom_medicament: action.value.nom_medicament,
        posologie: action.value.posologie,
      };
    case ACTION.Fill_FORM_SolaireAntiUV:
      return {
        ...state,
        SolaireAntiUV: !action.payload,
      };
    case ACTION.Fill_FORM_Antireflet:
      return {
        ...state,
        Antireflet: !action.payload,
      };
    case ACTION.Fill_FORM_Photocromic:
      return {
        ...state,
        Photocromic: !action.payload,
      };
    case ACTION.Fill_FORM_FiltreBlue:
      return {
        ...state,
        FiltreBlue: !action.payload,
      };
    case ACTION.CLOSE:
      return { open: false };
    case ACTION.OPEN:
      return {
        open: true,
        size: action.size,
        idx: action.idx,
        observation: "",
        od: "",
        od_Pachy: "",
        og: "",
        og_Pachy: "",
      };
    case ACTION.CLOSE2:
      return {
        ...state,
        open2: false,
      };
    case ACTION.OPEN2:
      return {
        ...state,
        open2: true,
        size2: action.size2,
      };
    case ACTION.UPDATE_ID:
      return {
        ...state,
        ID: action.payload,
      };
    case ACTION.Fill_FORM_DATA:
      return {
        ...state,
        FormData: action.payload,
      };
    case ACTION.Fill_FORM_DATA_3_COLUMN_ChangeDate:
      return {
        ...state,
        created_at: action.payload,
      };
    case ACTION.Fill_FORM_DATA_3_COLUMN_observation:
      return {
        ...state,
        observation: action.payload,
      };
    case ACTION.Fill_FORM_DATA_3_COLUMN_od:
      return {
        ...state,
        od: action.payload,
      };
    case ACTION.Fill_FORM_Montures_cadre:
      return {
        ...state,
        MontureNewAVOptions: action.payload,
      };
    case ACTION.Fill_FORM_DATA_3_COLUMN_avOD:
      return {
        ...state,
        avOD: action.payload,
      };
    case ACTION.Fill_FORM_DATA_3_COLUMN_sphOD:
      return {
        ...state,
        sphOD: action.payload,
      };
    case ACTION.Fill_FORM_DATA_3_COLUMN_cylOD:
      return {
        ...state,
        cylOD: action.payload,
      };
    case ACTION.Fill_FORM_DATA_3_COLUMN_axeOD:
      let strOD = action.payload;
      let nOD = strOD.indexOf("º");
      if (nOD >= 0) {
        strOD = strOD.slice(0, -1);
      } else {
        strOD = action.payload;
      }
      return {
        ...state,
        axeOD: `${strOD}º`,
      };
    case ACTION.Fill_FORM_DATA_3_COLUMN_addOD:
      return {
        ...state,
        addOD: action.payload,
      };
    case ACTION.Fill_FORM_DATA_3_COLUMN_avOG:
      return {
        ...state,
        avOG: action.payload,
      };
    case ACTION.Fill_FORM_DATA_3_COLUMN_sphOG:
      return {
        ...state,
        sphOG: action.payload,
      };
    case ACTION.Fill_FORM_DATA_3_COLUMN_cylOG:
      return {
        ...state,
        cylOG: action.payload,
      };
    case ACTION.Fill_FORM_DATA_3_COLUMN_axeOG:
      let str = action.payload;
      let n = str.indexOf("º");
      if (n >= 0) {
        str = str.slice(0, -1);
      } else {
        str = action.payload;
      }
      return {
        ...state,
        axeOG: `${str}º`,
      };
    case ACTION.Fill_FORM_DATA_3_COLUMN_addOG:
      return {
        ...state,
        addOG: action.payload,
      };
    case ACTION.Fill_FORM_DATA_3_COLUMN_od_Pachy:
      return {
        ...state,
        od_Pachy: action.payload,
      };
    case ACTION.Fill_FORM_DATA_3_COLUMN_og:
      return {
        ...state,
        og: action.payload,
      };
    case ACTION.Fill_FORM_DATA_3_COLUMN_og_Pachy:
      return {
        ...state,
        og_Pachy: action.payload,
      };
    case ACTION.IMPORT_DATA_MACHINE_PACHY:
      let data_od, data_og, data_od_pachy, data_og_pachy;
      if (action.payload.T_R_A) {
        data_od = action.payload.T_R_A;
      } else {
        data_od = "";
      }
      if (action.payload.T_L_A) {
        data_og = action.payload.T_L_A;
      } else {
        data_og = "";
      }
      if (action.payload.P_R_A) {
        data_od_pachy = action.payload.P_R_A;
      } else {
        data_od_pachy = "";
      }
      if (action.payload.P_L_A) {
        data_og_pachy = action.payload.P_L_A;
      } else {
        data_og_pachy = "";
      }
      return {
        ...state,
        // od: action.payload,
        // od_Pachy: action.payload,
        // og: action.payload,
        // og_Pachy: action.payload,
        od: data_od,
        od_Pachy: data_od_pachy,
        og: data_og,
        og_Pachy: data_og_pachy,
      };
    case ACTION.FETCH_SUCCESS:
      return {
        ...state,
        selectionChanged: false,
        loading: false,
        rowData: action.payload,
        Nom_Detail_1: "",
        error: "",
        // ModalHeader: action.title,
      };
    case ACTION.FETCH_SUCCESS2:
      return {
        ...state,
        loading: false,
        rowData2: action.payload,
        Nom_Detail_2: "",
        error: "",
        // fk_id_patient_ordo_medic: ""
      };
    case ACTION.FETCH_SUCCESS2UPDATE:
      // let varRdv, varOrdonnance_date3
      // if (action.payload[0].rdv) {
      //   varRdv = action.payload[0].rdv
      // } else {
      //   varRdv = null
      // }
      // if (action.payload[0].rdv) {
      //   varOrdonnance_date3 = action.payload[0].ordonnance_date2
      // } else {
      //   varOrdonnance_date3 = null
      // }
      return {
        ...state,
        loading: false,
        rowData2: action.payload,
        Nom_Detail_2: "",
        error: "",
        ordonnance_date3: action.payload[0].date_ordonance2,
        rdv: action.payload[0].rdv,
      };
    case ACTION.FETCH_SUCCESS2Mod:
      let x = state.rowData2;
      let j = action.payload;
      let myvariable;
      if (x) {
        myvariable = [...x, j];
      } else {
        x = [];
        myvariable = [...x, j];
      }

      return {
        ...state,
        rowData2: myvariable,
      };
    case ACTION.FETCH_SUCCESS2Mod2:
      let xx = state.rowData2;
      let jj = state.index;
      xx.splice(jj, 1);

      return {
        ...state,
        rowData2: xx,
      };
    case ACTION.FETCH_SUCCESS3:
      return {
        ...state,
        loading: false,
        rowData3: action.payload,
        Nom_Detail_3: "",
        error: "",
      };
    case ACTION.FETCH_UPLOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        uploads: action.payload,
        error: "",
      };
    case ACTION.IS_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };

    case ACTION.FETCH_DUO_SUCCESS:
      return {
        ...state,
        loading: false,
        rowData: action.payload,
        rowData2: action.payload2,
        error: "",
      };
    case ACTION.FETCH_ERROR:
      return {
        ...state,
        loading: false,
        users: [],
        error: action.payload,
      };

    case ACTION.UPDATE_SUCCESS:
      return {
        ...state,
        success: "Successfully updated",
        error: "",
        ID: action.payload,
      };
    case ACTION.UPDATE_SUCCESS_CONSULTATION:
      return {
        ...state,
        success: "Success",
        error: "",
        rowData: action.payload,
      };
    case ACTION.UPDATE_ACT_SUCCESS:
      return {
        ...state,
        success: "Successfully updated",
        error: "",
      };
    case ACTION.DELETE_SUCCESS:
      return {
        ...state,
        success: "Successfully deleted",
        error: "",
      };
    case ACTION.DELETE_SUCCESS1:
      // rowData.splice( rowData.findIndex(a => a.id === 37) , 1);
      return {
        ...state,
        success: "Successfully deleted",
        error: "",
      };
    case ACTION.CREATE_SUCCESS:
      return {
        success: "Successfully created",
        error: "",
        ID: action.payload.insertId,
      };
    case ACTION.CREATE_ACT_SUCCESS:
      return {
        ...state,
        success: "Successfully added",
        error: "",
      };
    case ACTION.CREATE_ACT_SUCCESS_CLEAR:
      return {
        ...state,
        success: "",
        error: "",
      };
    case ACTION.CREATE_ERROR:
      return {
        ...state,
        success: "",
        error: "Something went wrong",
      };
    case ACTION.FORM_LOAD:
      return {
        ...state,
        idpatient: action.value.idpatient,
        nom: action.value.nom,
        prenom: action.value.prenom,
        civilite: action.value.civilite,
        nom_mutuelle: action.value.nom_mutuelle,
        fk_id_liste_mutuelle: action.value.fk_id_liste_mutuelle,
        fk_id_civilite: action.value.fk_id_civilite,
        cin: action.value.cin,
        date_naissance: action.value.date_naissance,
        commentaire_sur_patient: action.value.commentaire_sur_patient,
        tel: action.value.tel,
        tel2: action.value.tel2,
        tel3: action.value.tel3,
        pathname: action.pathname,
      };
    case ACTION.FORM_LOAD_CONSULTATION:
      const {
        DateConsultation,
        created_at,
        created_by,
        fk_id_examen,
        fk_id_patientConsul,
        id_consultation,
        nom_examen,
        observation,
        od,
        og,
        updated_at,
        updated_by,
        ODprintableText,
        OGprintableText,
      } = action.value.clientArray;
      return {
        ...state,
        DateConsultation,
        created_at,
        created_by,
        fk_id_examen,
        fk_id_patientConsul,
        id_consultation,
        nom_examen,
        observation,
        od,
        og,
        updated_at,
        updated_by,
        ODprintableText,
        OGprintableText,
      };
    case ACTION.LOAD_FIRST_TABLE:
      const {
        id_examen,
        Nom_CategoryBtn,
        Nom_Detail_1,
        fk_id_categoryBtn,
        id_detail_1,
      } = action.value;
      return {
        ...state,
        id_examen,
        Nom_CategoryBtn,
        Nom_Detail_1,
        fk_id_categoryBtn,
        id_detail_1,
        rowData3: [],
      };
    case ACTION.LOAD_CRUD_OPTIONS:
      const {
        key1,
        category,
        value
      } = action.value;
      return {
        ...state,
        key1,
        category,
        value
      };
    case ACTION.LOAD_History_examen_compl:
      const {
        idExamens_Compl,
        nom_Examens_Compl,
        fk_id_patient_examen_compl,
        date_exam_compl,
        date_exam_compl_converted,
      } = action.value;
      return {
        ...state,
        idExamens_Compl,
        nom_Examens_Compl,
        fk_id_patient_examen_compl,
        date_exam_compl,
        date_exam_compl_converted,
      };
    case ACTION.LOAD_LUNETTES_TABLE:
      const {
        fk_id_patientLunette,
        avOD,
        sphOD,
        cylOD,
        axeOD,
        addOD,
        id_lunettes,
        avOG,
        sphOG,
        cylOG,
        axeOG,
        addOG,
        nomPrenomCivilite,
        SolaireAntiUV,
        Antireflet,
        FiltreBlue,
        Photocromic,
        selectionChanged,
        MontureNewAVOptions,
        TypeCO,
      } = action.value;

      // console.log(action.value.observation, "action.value.observation");
      let dateToConvert = action.value.created_at;

      var dateParts = dateToConvert.split("/");

      var cellDate = new Date(
        Number(dateParts[2]),
        Number(dateParts[1]) - 1,
        Number(dateParts[0])
      );
      let fix = moment(cellDate).format("YYYY-MM-DD");

      return {
        ...state,
        fk_id_patientLunette,
        avOD,
        sphOD,
        cylOD,
        axeOD,
        addOD,
        id_lunettes,
        avOG,
        sphOG,
        cylOG,
        axeOG,
        addOG,
        observation: action.value.observation,
        nomPrenomCivilite,
        created_at: action.value.created_at,
        created_atServer: fix,
        SolaireAntiUV,
        Antireflet,
        FiltreBlue,
        Photocromic,
        selectionChanged,
        MontureNewAVOptions,
        TypeCO,
        fk_id_examen: action.value.fk_id_examen,
      };
    case ACTION.IMPORT_DATA_MACHINE_CO_PORTEE:
      let xxx = {};

      if (
        action.payload.Lensometry_R_SPH &&
        action.payload.Lensometry_R_SPH !== "0.0"
      ) {
        xxx.sphOD = action.payload.Lensometry_R_SPH;
      } else {
        xxx.sphOD = "";
      }

      if (
        action.payload.Lensometry_R_CYL &&
        action.payload.Lensometry_R_CYL !== "0.0"
      ) {
        xxx.cylOD = action.payload.Lensometry_R_CYL;
      } else {
        xxx.cylOD = "";
      }
      if (
        action.payload.Lensometry_R_AXS &&
        action.payload.Lensometry_R_CYL &&
        action.payload.Lensometry_R_CYL !== "0.0"
      ) {
        xxx.axeOD = action.payload.Lensometry_R_AXS;
      } else {
        xxx.axeOD = "";
      }
      if (action.payload.a20 && action.payload.a20 !== "0.0") {
        xxx.addOD = action.payload.a20;
      } else {
        xxx.addOD = "";
      }

      if (
        action.payload.Lensometry_L_SPH &&
        action.payload.Lensometry_L_SPH !== "0.0"
      ) {
        xxx.sphOG = action.payload.Lensometry_L_SPH;
      } else {
        xxx.sphOG = "";
      }

      if (
        action.payload.Lensometry_L_CYL &&
        action.payload.Lensometry_L_CYL !== "0.0"
      ) {
        xxx.cylOG = action.payload.Lensometry_L_CYL;
      } else {
        xxx.cylOG = "";
      }
      if (
        action.payload.Lensometry_L_AXS &&
        action.payload.Lensometry_L_CYL &&
        action.payload.Lensometry_L_CYL !== "0.0"
      ) {
        xxx.axeOG = action.payload.Lensometry_L_AXS;
      } else {
        xxx.axeOG = "";
      }
      if (action.payload.a26 && action.payload.a26 !== "0.0") {
        xxx.addOG = action.payload.a26;
      } else {
        xxx.addOG = "";
      }

      let VarsphOD,
        VarcylOD,
        VaraxeOD,
        VarsphOG,
        VarcylOG,
        VaraxeOG,
        VaraddOG,
        VaraddOD;

      if (xxx.addOG.includes("-")) {
        VaraddOG = parseFloat(xxx.addOG).toFixed(2).replace("-", "- ");
      } else if (xxx.addOG) {
        // VarsphODfinale = `+ ${xxx.sphOD}`
        if (xxx.addOG === "nan") {
          VaraddOG = "";
        } else {
          VaraddOG = `+ ${parseFloat(xxx.addOG).toFixed(2)}`;
        }
      }

      if (xxx.addOD.includes("-")) {
        VaraddOD = parseFloat(xxx.addOD).toFixed(2).replace("-", "- ");
      } else if (xxx.addOD) {
        // VarsphODfinale = `+ ${xxx.sphOD}`
        if (xxx.addOD === "nan") {
          VaraddOD = "";
        } else {
          VaraddOD = `+ ${parseFloat(xxx.addOD).toFixed(2)}`;
        }
      }

      if (xxx.axeOD) {
        if (xxx.axeOD === "nan") {
          VaraxeOD = "";
        } else {
          VaraxeOD = `${xxx.axeOD}º`;
        }
      }

      if (xxx.axeOG) {
        if (xxx.axeOG === "nan") {
          VaraxeOG = "";
        } else {
          VaraxeOG = `${xxx.axeOG}º`;
        }
      }

      if (xxx.sphOD.includes("-")) {
        // VarsphOD = xxx.sphOD.replace("-", "- ")
        // VarsphOD = xxx.sphOD.toFixed(2)
        VarsphOD = parseFloat(xxx.sphOD).toFixed(2).replace("-", "- ");
      } else if (xxx.sphOD) {
        if (xxx.sphOD === "nan") {
          VarsphOD = "";
        } else {
          VarsphOD = `+ ${parseFloat(xxx.sphOD).toFixed(2)}`;
        }
        // VarsphOD = `+ ${xxx.sphOD}`
      }

      if (xxx.cylOD.includes("-")) {
        // VarcylOD = xxx.cylOD.replace("-", "- ")
        VarcylOD = parseFloat(xxx.cylOD).toFixed(2).replace("-", "- ");
      } else if (xxx.cylOD) {
        if (xxx.cylOD === "nan") {
          VarcylOD = "";
        } else {
          VarcylOD = `+ ${parseFloat(xxx.cylOD).toFixed(2)}`;
        }
        // VarcylOD = `+ ${xxx.sphOD}`
      }

      if (xxx.sphOG.includes("-")) {
        // VarsphOG = xxx.sphOG.replace("-", "- ")
        VarsphOG = parseFloat(xxx.sphOG).toFixed(2).replace("-", "- ");
      } else if (xxx.sphOG) {
        if (xxx.sphOG === "nan") {
          VarsphOG = "";
        } else {
          VarsphOG = `+ ${parseFloat(xxx.sphOG).toFixed(2)}`;
        }
        // VarsphOG = `+ ${xxx.sphOG}`
      }

      if (xxx.cylOG.includes("-")) {
        // VarcylOG = xxx.cylOG.replace("-", "- ")
        VarcylOG = parseFloat(xxx.cylOG).toFixed(2).replace("-", "- ");
      } else if (xxx.cylOG) {
        if (xxx.cylOG === "nan") {
          VarcylOG = "";
        } else {
          VarcylOG = `+ ${parseFloat(xxx.cylOG).toFixed(2)}`;
        }
        // VarcylOG = `+ ${xxx.sphOG}`
      }

      return {
        ...state,
        sphOD: VarsphOD === undefined ? "" : VarsphOD,
        cylOD: VarcylOD === undefined ? "" : VarcylOD,
        axeOD: VaraxeOD === undefined ? "" : VaraxeOD,
        addOD: VaraddOD === undefined ? "" : VaraddOD,
        sphOG: VarsphOG === undefined ? "" : VarsphOG,
        cylOG: VarcylOG === undefined ? "" : VarcylOG,
        axeOG: VaraxeOG === undefined ? "" : VaraxeOG,
        addOG: VaraddOG === undefined ? "" : VaraddOG,
      };
    ////////////////////////////////////////////////////////////////////////////////////////
    case ACTION.IMPORT_DATA_MACHINE_CO_finale:
      let xxxfinale = {};

      if (
        action.payload.Final_Prescription_R_SPH &&
        action.payload.Final_Prescription_R_SPH !== "0.0"
      ) {
        xxxfinale.sphOD = action.payload.Final_Prescription_R_SPH;
      } else {
        xxxfinale.sphOD = "";
      }

      if (
        action.payload.Final_Prescription_R_CYL &&
        action.payload.Final_Prescription_R_CYL !== "0.0"
      ) {
        xxxfinale.cylOD = action.payload.Final_Prescription_R_CYL;
      } else {
        xxxfinale.cylOD = "";
      }
      if (
        action.payload.Final_Prescription_R_AXS &&
        action.payload.Final_Prescription_R_CYL &&
        action.payload.Final_Prescription_R_CYL !== "0.0"
      ) {
        xxxfinale.axeOD = action.payload.Final_Prescription_R_AXS;
      } else {
        xxxfinale.axeOD = "";
      }
      if (
        action.payload.Final_Prescription_R_ADD &&
        action.payload.Final_Prescription_R_ADD !== "0.0"
      ) {
        xxxfinale.addOD = action.payload.Final_Prescription_R_ADD;
      } else {
        xxxfinale.addOD = "";
      }

      if (
        action.payload.Final_Prescription_L_SPH &&
        action.payload.Final_Prescription_L_SPH !== "0.0"
      ) {
        xxxfinale.sphOG = action.payload.Final_Prescription_L_SPH;
      } else {
        xxxfinale.sphOG = "";
      }

      if (
        action.payload.Final_Prescription_L_CYL &&
        action.payload.Final_Prescription_L_CYL !== "0.0"
      ) {
        xxxfinale.cylOG = action.payload.Final_Prescription_L_CYL;
      } else {
        xxxfinale.cylOG = "";
      }
      if (
        action.payload.Final_Prescription_L_AXS &&
        action.payload.Final_Prescription_L_CYL &&
        action.payload.Final_Prescription_L_CYL !== "0.0"
      ) {
        xxxfinale.axeOG = action.payload.Final_Prescription_L_AXS;
      } else {
        xxxfinale.axeOG = "";
      }
      if (
        action.payload.Final_Prescription_L_ADD &&
        action.payload.Final_Prescription_L_ADD !== "0.0"
      ) {
        xxxfinale.addOG = action.payload.Final_Prescription_L_ADD;
      } else {
        xxxfinale.addOG = "";
      }

      let VarsphODfinale,
        VarcylODfinale,
        VaraxeODfinale,
        VarsphOGfinale,
        VarcylOGfinale,
        VaraxeOGfinale,
        VaraddOGfinale,
        VaraddODfinale;

      if (xxxfinale.addOG.includes("-")) {
        // VarsphODfinale = xxxfinale.sphOD.replace("-", "- ")
        // VarsphODfinale = xxxfinale.sphOD.toFixed(2)
        VaraddOGfinale = parseFloat(xxxfinale.addOG)
          .toFixed(2)
          .replace("-", "- ");
      } else if (xxxfinale.addOG) {
        if (xxxfinale.addOG === "nan") {
          VaraddOGfinale = "";
        } else {
          VaraddOGfinale = `+ ${parseFloat(xxxfinale.addOG).toFixed(2)}`;
        }
        // VarsphODfinale = `+ ${xxxfinale.sphOD}`
      }

      if (xxxfinale.addOD.includes("-")) {
        // VarsphODfinale = xxxfinale.sphOD.replace("-", "- ")
        // VarsphODfinale = xxxfinale.sphOD.toFixed(2)
        VaraddODfinale = parseFloat(xxxfinale.addOD)
          .toFixed(2)
          .replace("-", "- ");
      } else if (xxxfinale.addOD) {
        if (xxxfinale.addOD === "nan") {
          VaraddODfinale = "";
        } else {
          VaraddODfinale = `+ ${parseFloat(xxxfinale.addOD).toFixed(2)}`;
        }
        // VarsphODfinale = `+ ${xxxfinale.sphOD}`
      }

      if (xxxfinale.axeOD) {
        if (xxxfinale.axeOD === "nan") {
          VaraxeODfinale = "";
        } else {
          VaraxeODfinale = `${xxxfinale.axeOD}º`;
        }
      }

      if (xxxfinale.axeOG) {
        if (xxxfinale.axeOG === "nan") {
          VaraxeOGfinale = "";
        } else {
          VaraxeOGfinale = `${xxxfinale.axeOG}º`;
        }
      }

      if (xxxfinale.sphOD.includes("-")) {
        // VarsphODfinale = xxxfinale.sphOD.replace("-", "- ")
        // VarsphODfinale = xxxfinale.sphOD.toFixed(2)
        VarsphODfinale = parseFloat(xxxfinale.sphOD)
          .toFixed(2)
          .replace("-", "- ");
      } else if (xxxfinale.sphOD) {
        if (xxxfinale.sphOD === "nan") {
          VarsphODfinale = "";
        } else {
          VarsphODfinale = `+ ${parseFloat(xxxfinale.sphOD).toFixed(2)}`;
        }
        // VarsphODfinale = `+ ${xxxfinale.sphOD}`
      }

      if (xxxfinale.cylOD.includes("-")) {
        // VarcylODfinale = xxxfinale.cylOD.replace("-", "- ")
        VarcylODfinale = parseFloat(xxxfinale.cylOD)
          .toFixed(2)
          .replace("-", "- ");
      } else if (xxxfinale.cylOD) {
        if (xxxfinale.cylOD === "nan") {
          VarcylODfinale = "";
        } else {
          VarcylODfinale = `+ ${parseFloat(xxxfinale.cylOD).toFixed(2)}`;
        }
        // VarcylODfinale = `+ ${xxxfinale.sphOD}`
      }

      if (xxxfinale.sphOG.includes("-")) {
        // VarsphOGfinale = xxxfinale.sphOG.replace("-", "- ")
        VarsphOGfinale = parseFloat(xxxfinale.sphOG)
          .toFixed(2)
          .replace("-", "- ");
      } else if (xxxfinale.sphOG) {
        if (xxxfinale.sphOG === "nan") {
          VarsphOGfinale = "";
        } else {
          VarsphOGfinale = `+ ${parseFloat(xxxfinale.sphOG).toFixed(2)}`;
        }
        // VarsphOGfinale = `+ ${xxxfinale.sphOG}`
      }

      if (xxxfinale.cylOG.includes("-")) {
        // VarcylOGfinale = xxxfinale.cylOG.replace("-", "- ")
        VarcylOGfinale = parseFloat(xxxfinale.cylOG)
          .toFixed(2)
          .replace("-", "- ");
      } else if (xxxfinale.cylOG) {
        if (xxxfinale.cylOG === "nan") {
          VarcylOGfinale = "";
        } else {
          VarcylOGfinale = `+ ${parseFloat(xxxfinale.cylOG).toFixed(2)}`;
        }
        // VarcylOGfinale = `+ ${xxxfinale.sphOG}`
      }

      return {
        ...state,
        sphOD: VarsphODfinale === undefined ? "" : VarsphODfinale,
        cylOD: VarcylODfinale === undefined ? "" : VarcylODfinale,
        axeOD: VaraxeODfinale === undefined ? "" : VaraxeODfinale,
        addOD: VaraddODfinale === undefined ? "" : VaraddODfinale,
        sphOG: VarsphOGfinale === undefined ? "" : VarsphOGfinale,
        cylOG: VarcylOGfinale === undefined ? "" : VarcylOGfinale,
        axeOG: VaraxeOGfinale === undefined ? "" : VaraxeOGfinale,
        addOG: VaraddOGfinale === undefined ? "" : VaraddOGfinale,
      };
    case ACTION.LOAD_SECOND_TABLE:
      const { Nom_Detail_2, fk_id_detail_1, id_detail_2 } = action.value;
      return {
        ...state,
        Nom_Detail_2,
        fk_id_detail_1,
        id_detail_2,
      };
    case ACTION.LOAD_THIRD_TABLE:
      const { Nom_Detail_3, fk_id_detail_2, id_detail_3 } = action.value;
      return {
        ...state,
        Nom_Detail_3,
        fk_id_detail_2,
        id_detail_3,
      };

    case ACTION.ACT_FORM_LOAD:
      return {
        ...state,
        age: "",
        nom: "",
        prenom: "",
        couleur: "",
        created_at: "",
        date_consultation: "",
        date_naissance: "",
        done: "",
        fk_id_acte: "",
        fk_id_patient1: "",
        nom_acte: "",
        rest: "",
        sum_act: "",
        bloc: "",
        didnt_come: "",
      };
    case ACTION.GET_PATHNAME:
      return {
        ...state,
        pathname: action.payload,
      };
    case ACTION.COPY_OD_TO_OG:
      return {
        ...state,
        avOG: state.avOD,
        sphOG: state.sphOD,
        cylOG: state.cylOD,
        axeOG: state.axeOD,
        addOG: state.addOD,
      };
    default:
      return state;
  }
};
